import request from "../../utils/request";

export function doGetSetting() {
  return request("/companies/setting", {
    method: "GET",
  });
}

export function doUpdateSetting(params) {
  return request("/companies/setting", {
    method: "POST",
    data: params,
  });
}

export function doUpdateBrandSetting(params) {
  return request("/companies/brand-settings", {
    method: "POST",
    data: params,
  });
}

export function doLanguageTranslate(params) {
  return request("/language/translate", {
    method: "POST",
    data: params,
  });
}
